export default __webpack_public_path__ + "static/media/machinelearning.e55ca9d8.png";